<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <!--
              <img src="@/assets/images/pages/register.jpg" alt="register" class="mx-auto" />
              -->
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="px-8 pt-8 register-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Create Account</h4>
                  <p>Fill the below form to create a new account.</p>

                  <div class="clearfix">
                    <vs-input
                      data-vv-validate-on="blur"
                      label-placeholder="Name"
                      name="name"
                      placeholder="Name"
                      v-model="form.name"
                      class="w-full"
                    />

                    <vs-input
                      data-vv-validate-on="blur"
                      name="email"
                      type="email"
                      label-placeholder="Email"
                      placeholder="Email"
                      v-model="form.email"
                      class="w-full mt-6"
                    />

                    <vs-input
                      ref="password"
                      type="password"
                      data-vv-validate-on="blur"
                      name="password"
                      label-placeholder="Password"
                      placeholder="Password"
                      v-model="form.password"
                      class="w-full mt-6"
                    />

                    <vs-input
                      type="password"
                      data-vv-validate-on="blur"
                      data-vv-as="password"
                      name="confirm_password"
                      label-placeholder="Confirm Password"
                      placeholder="Confirm Password"
                      v-model="form.confirm_password"
                      class="w-full mt-6"
                    />

                    <vs-checkbox
                      v-model="form.isTermsConditionAccepted"
                      class="mt-6"
                    >I accept the terms & conditions.</vs-checkbox>
                    <vs-button type="border" to="/login" class="mt-6">Login</vs-button>
                    <vs-button
                      class="float-right mt-6"
                      @click="registerUserJWt"
                      :disabled="!validateForm"
                    >Register</vs-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        password: "",
        confirm_password: "",
        isTermsConditionAccepted: true
      }
    };
  },
  computed: {
    validateForm() {
      return (
        this.form.name != "" &&
        this.form.email != "" &&
        this.form.password != "" &&
        this.form.confirm_password != "" &&
        this.form.isTermsConditionAccepted === true
      );
    }
  },
  methods: {
    checkLogin() {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {
        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: "Login Attempt",
          text: "You are already logged in!",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning"
        });

        return false;
      }
      return true;
    },
    registerUserJWt() {
      // If form is not validated or user is already login return
      if (!this.validateForm) return;

      this.$store.dispatch("Auth/register", this.form).then(res => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Register complete.",
            color: "success"
          });
          this.$router.push("/login");
        }
      });
    }
  }
};
</script>

<style lang="scss">
.register-tabs-container {
  min-height: 517px;

  .con-tab {
    padding-bottom: 23px;
  }
}
</style>
